export default __webpack_public_path__ + "static/media/branch.fa70c027.svg";